import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { i18nReducer as i18n } from 'react-redux-i18n';

import auth from './auth';
import ide from './ide';
import utils from './utils';
import register from './register';
import tasks from './tasks';
import projects from './projects';
import courses from './courses';
import socket from './socket';
import commands from './commands';
import admin from './admin';
import feedback from './feedback';

const appReducers = combineReducers({
  admin,
  auth,
  commands,
  courses,
  feedback,
  ide,
  i18n,
  projects,
  register,
  socket,
  tasks,
  utils,
  routing: routerReducer,
});

export default appReducers;
